import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          work in progress, brb.<br></br>
          created by gabbie piraino.
        </p>
      </header>
    </div>
  );
}

export default App;
